const LOCAL = 'fr-FR';

const DEFAULT_NUMERIC_OPTIONS = {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric'
};

const toHumanReadableDateTime = (isoDate, options = DEFAULT_NUMERIC_OPTIONS) => {
    const date = new Date(isoDate);

    return date.toLocaleTimeString(LOCAL, options);
};

const toHumanReadableDate = (isoDate, options = DEFAULT_NUMERIC_OPTIONS) => {
    const date = new Date(isoDate);

    return date.toLocaleDateString(LOCAL, options);
};

const toHumanReadableFriendlyDateTime = isoString => {
    if (!isoString) return '';
    const d = new Date(isoString);
    const date = d.toLocaleDateString('fr-FR', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    });
    const time = d.toLocaleTimeString('fr-FR', {
        hour: '2-digit',
        minute: '2-digit'
    });
    return `${date} à ${time}`;
};

const daysSince = dateStr => {
    if (!dateStr) return null;
    const [y, m, d] = dateStr.split('-').map(Number);
    if (!d || !m || !y) return null;
    const past = new Date(y, m - 1, d);
    const now = new Date();
    return Math.floor((now - past) / 86400000);
};

export {
    toHumanReadableDateTime,
    toHumanReadableDate,
    DEFAULT_NUMERIC_OPTIONS,
    daysSince,
    toHumanReadableFriendlyDateTime
};
